import { Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { authGuard } from './core/auth/auth.guard';
import { pwdChangeGuard } from './core/auth/pwd-change.guard';
import { BarChart3, Users, ListTodo, ShieldAlert, DollarSign, Settings, GraduationCap } from 'lucide-angular';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./modules/access/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'access/change-password',
    loadComponent: () =>
      import('./modules/access/change-password.component').then(m => m.ChangePasswordComponent),
    canActivate: [pwdChangeGuard],
  },
  {
    path: 'access/error',
    loadComponent: () =>
      import('./modules/access/error.component').then(m => m.ErrorComponent),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./modules/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'deals',
        loadComponent: () =>
          import('./modules/deals/deals.component').then(m => m.DealsComponent),
      },
      // Generic sections -- each with children wildcard to catch sidebar sub-paths
      {
        path: 'merchants/new',
        loadComponent: () =>
          import('./modules/merchants/merchant-form.component').then(m => m.MerchantFormComponent),
      },
      {
        path: 'merchants/:id/edit',
        loadComponent: () =>
          import('./modules/merchants/merchant-form.component').then(m => m.MerchantFormComponent),
      },
      {
        path: 'merchants/:id',
        loadComponent: () =>
          import('./modules/merchants/merchant-detail.component').then(m => m.MerchantDetailComponent),
      },
      {
        path: 'merchants',
        loadComponent: () =>
          import('./modules/merchants/merchants.component').then(m => m.MerchantsComponent),
        children: [{ path: '**', redirectTo: '' }],
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./shared/components/generic-section/generic-section.component').then(m => m.GenericSectionComponent),
        data: { sectionLabel: 'Reports', sectionIcon: BarChart3 },
        children: [{ path: '**', redirectTo: '' }],
      },
      {
        path: 'agents',
        loadComponent: () =>
          import('./modules/agents/agents.component').then(m => m.AgentsComponent),
        children: [{ path: '**', redirectTo: '' }],
      },
      {
        path: 'workflow',
        loadComponent: () =>
          import('./shared/components/generic-section/generic-section.component').then(m => m.GenericSectionComponent),
        data: { sectionLabel: 'Workflow', sectionIcon: ListTodo },
        children: [{ path: '**', redirectTo: '' }],
      },
      {
        path: 'risk',
        loadComponent: () =>
          import('./shared/components/generic-section/generic-section.component').then(m => m.GenericSectionComponent),
        data: { sectionLabel: 'Risk', sectionIcon: ShieldAlert },
        children: [{ path: '**', redirectTo: '' }],
      },
      {
        path: 'residues',
        loadComponent: () =>
          import('./shared/components/generic-section/generic-section.component').then(m => m.GenericSectionComponent),
        data: { sectionLabel: 'Residues', sectionIcon: DollarSign },
        children: [{ path: '**', redirectTo: '' }],
      },
      // System and University -- loadComponent points to actual implementations (created in Plan 02)
      {
        path: 'system',
        loadComponent: () =>
          import('./modules/system/system.component').then(m => m.SystemComponent),
        children: [{ path: '**', redirectTo: '' }],
      },
      {
        path: 'university',
        loadComponent: () =>
          import('./modules/university/university.component').then(m => m.UniversityComponent),
        children: [{ path: '**', redirectTo: '' }],
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '/login' },
];
